import { action, observable } from "mobx";

export type Page =
    | { name: "welcome" }
    | { name: "login" }
    | { name: "setup" }
    | { name: "workers" }
    | { name: "worker"; key: string }
    | { name: "start" }
    | { name: "settings" };

/** What's on screen. */
export class UiStore {
    @observable accessor page: Page = { name: "workers" };

    @action show(page: Page): void {
        this.page = page;
    }
}
